export class PropertyValue {
    constructor(public Id: number, public Value: string, public IsValid?: boolean) {
    }
}